<template>
  <v-card flat class="mt-3 layerItem">
    <v-card-title class="py-0">
      <v-switch hide-details :label="item.title" v-model="visible" />
    </v-card-title>

    <v-card-text class="py-2">
      <v-slider v-if="opacity > 0" v-model="opacity" label="Opacidad" min="10" max="100" step="10" hide-details />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'

// import * as ArcGIS from '../../helpers/ArcGIS'

export default {
  props: {
    item: {
      type: Object,
      default: () => { return {} }
    }
  },

  data: () => ({
    visible: false,
    opacity: null
  }),

  watch: {
    visible () {
      if (this.visible) {
        this.$emit('setVisible')
      }

      this.setVisibilityLayer({
        id: this.item.id,
        visible: this.visible,
        item: this.item
      })
      // ArcGIS.setVisibilityLayer(this.item.id, this.visible)
    },
    opacity () {
      this.setOpacityLayer({
        id: this.item.id,
        opacity: this.opacity / 100,
        item: this.item
      })
      // ArcGIS.setOpacityLayer(this.item.id, this.opacity / 100)
    }
  },

  methods: {
    ...mapActions('map', [
      'setVisibilityLayer',
      'setOpacityLayer'
    ])
  },

  created () {
    this.visible = this.item.visible

    if (this.item.opacity) {
      this.opacity = this.item.opacity * 100
    }
  }
}
</script>

<style scoped>
  .layerItem {
    background: #ebebeb;
    border-radius: 10px;
  }
</style>
